import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import { ReactComponent as SettingIcon } from "../../../assets/icons/setting-colored.svg";
import AutoInvestmentFundStatusCard from "../../../components/auto-investment/AutoInvestmentFundStatusCard";
import { AutoInvestmentStatusBottomSheet } from "../../../components/auto-investment/AutoInvestMentStatusBottomSheet";

function AutoInvestmentStatusPage() {
  const navigate = useNavigate();
  const { autoInvestmentStatus, setAutoInvestmentStatus } = useOutletContext();

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleSubmit = () => {
    navigate("../add-or-remove");
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            سرمایه‌گذاری خودکار
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Box
          onClick={() => {
            setOpenDrawer(true);
          }}
          sx={{
            minHeight: 42,
            p: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: (theme) => theme.shadows[2],
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" color="grey.4">
            تنظیمات سرمایه‌گذاری خودکار
          </Typography>
          <SettingIcon width={24} height={24} />
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 2 }}>
          {autoInvestmentStatus.items.map((item, index) => {
            return (
              <AutoInvestmentFundStatusCard
                sx={{
                  my: 1,
                }}
                disable={!autoInvestmentStatus.enabled}
                item={item}
                first={index === 0}
                wallet={autoInvestmentStatus.wallet}
              />
            );
          })}
        </Box>
        <BottomFullWidthButtonContainer>
          <Button
            disabled={!autoInvestmentStatus.enabled}
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            حذف و اضافه کردن صندوق‌ها
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
      <AutoInvestmentStatusBottomSheet
        open={openDrawer}
        setOpen={setOpenDrawer}
        setAutoInvestmentStatus={setAutoInvestmentStatus}
        enabled={autoInvestmentStatus.enabled}
      />
    </>
  );
}

export default AutoInvestmentStatusPage;
